import * as API from '@/endpoints'
import Axios from 'axios'
import Vue from 'vue'
import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    data: [],
    next_link: null,
    last_page: null,
    modal: {
      show: false,
      notification: null
    },
    status: {
      new: 0,
      total: 0
    }
  },
  mutations: {
    setData (state, payload) {
      state.data.push(...payload)
    },
    clearData (state) {
      state.data = []
    },
    setNextLink (state, nextPage) {
      state.next_link = nextPage
    },
    setLastPage (state, page) {
      state.last_page = page
    },
    setShowModal (state, v) {
      state.modal.show = v
    },
    setNotification (state, v) {
      state.modal.notification = v
    },
    setStatus (state, status) {
      state.status = status
    },
    removeNotificationById(state, id) {
      for( let x=0;x<state.data.length; x++) {
        if (state.data[x].more_data.invitation_id == id) {
          state.data.splice(x, 1);
          break;
        }
      }
    },
    updateNotificationItem(state, payload) {
      for( let x=0;x<state.data.length; x++) {
        if (state.data[x].id == payload.id) {
          state.data[x].is_new = 0
          // state.data.splice(x, 1);
          break;
        }
      }
    },
    setNotificationNewStatus(state, payload) {
      let index = _.findIndex(state.data, e => e.id === payload.id)

      if(index >= 0) {
        state.data[index].is_new = false
      }
    }
  },
  actions: {
    /**
     * Checks user status
     */
    checkStatus ({commit}) {
      return Axios.post(API.endpoints.base + `member/notification/status`)
        .then((res) => {
          commit('setStatus', res.data)
        })
    },
    /**
     * Get all the notifications of the user
     */
    getNotifications ({commit, state}, p = null) {
      let params = {
        page: (p ? p : state.last_page + 1)
      }

      return Axios.get(API.endpoints.base + `notification`, {params})
        .then(res => {
          if ( parseInt(res.data.page) === 1) {
            commit('clearData')
            commit('setLastPage', 1)
          }
          if (parseInt(res.data.page) > parseInt(state.last_page)) {
            commit('setLastPage', parseInt(res.data.page))
          }

          commit('setData', res.data.data)
          commit('setNextLink', res.data.next_link)
        })
    },
    /**
     * Update our last viewed state to have a flag what notification we last viewed
     */
    updateLastViewedState ({dispatch, state}) {
      // return Axios.post(API.endpoints.base + `member/notification/viewed`)

      let notifications = []
      for( let x=0;x<state.data.length; x++) {
        // if (state.data[x].is_new == true) dispatch("updateViewedNotification", state.data[x].id)
        if (state.data[x].is_new == true) notifications.push(state.data[x])
      }

      let notification_ids = notifications.map(notifs => {
        if (notifs.is_new) return notifs.id
      })

      dispatch("updateViewedNotification", {is_new: 0, notification_ids})
    },
    // updateViewedNotification({commit}, id) {
    //   let params = {
    //     is_new: 0
    //   }
    //   let url = API.endpoints.base + `notification/${id}`

    //   return Axios.put(url, params)
    //     .then((res) => {
    //       commit('updateNotificationItem', res.data)
    //     })
    // },
    updateViewedNotification({commit}, payload) {
      // console.log(payload)
      let url = API.endpoints.base + `notifications`

      return Axios.put(url, payload)
        .then((res) => {
          // commit('updateNotificationItem', res.data)
        })
    }
  }
}
